export const G2_SURVEY_LINK = 'https://www.g2.com/products/rask-ai/reviews';
export const BULLETS = [
  'Share your honest feedback on G2',
  'Send a screenshot of your review to our support chat',
  'Enjoy your bonus 25 minutes!',
];
